import { ProjectTemplateVersion } from '@/types/project-templates'
import useDeleteDetail, {
  UseDeleteDetailOptions,
} from '../core-hooks/useDeleteDetail'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import useUpdateDetail, {
  UseUpdateDetailOptions,
} from '../core-hooks/useUpdateDetail'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<ProjectTemplateVersion>({
  pathCategory: 'project_template_versions',
})

export function useGetProjectTemplateVersion({
  id,
  ...options
}: UseGetDetailOptions<ProjectTemplateVersion>) {
  const query = useGetDetail<ProjectTemplateVersion>({
    id,
    queryKey: queryKeys.projectTemplateVersions.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    projectTemplateVersion: query.data,
    ...query,
  }
}

export function useGetProjectTemplateVersions({
  filters,
  ...options
}: UseGetListOptions<ProjectTemplateVersion> = {}) {
  const query = useGetList<ProjectTemplateVersion>({
    filters,
    queryKey: queryKeys.projectTemplateVersions.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    projectTemplateVersions: query.allData,
    ...query,
  }
}

export function useDeleteProjectTemplateVersion(
  options: UseDeleteDetailOptions = {},
) {
  const mutation = useDeleteDetail<ProjectTemplateVersion>({
    serviceFn: service.deleteDetail,
    ...options,
  })

  return {
    deleteProjectTemplateVersion: mutation.mutate,
    deleteProjectTemplateVersionAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useUpdateProjectTemplateVersion(
  options: UseUpdateDetailOptions<ProjectTemplateVersion> = {},
) {
  const mutation = useUpdateDetail<ProjectTemplateVersion>({
    serviceFn: service.updateDetail,
    ...options,
  })

  return {
    updateProjectTemplateVersion: mutation.mutate,
    updateProjectTemplateVersionAsync: mutation.mutateAsync,
    ...mutation,
  }
}
